"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAudienceStatDailyTotal = getAudienceStatDailyTotal;
exports.getLegacyDailyAudienceFallback = getLegacyDailyAudienceFallback;
exports.resolveDailyAudience = resolveDailyAudience;
exports.getAverageDailyAudience = getAverageDailyAudience;
function toFiniteNonNegativeNumber(value) {
    if (value === null || value === undefined || (typeof value === "string" && value.trim() === "")) {
        return undefined;
    }
    if (typeof value !== "number" && typeof value !== "string") {
        return undefined;
    }
    const numericValue = Number(value);
    return Number.isFinite(numericValue) && numericValue >= 0 ? numericValue : undefined;
}
function getAudienceStatDailyTotal(stat) {
    const dailyTotal = toFiniteNonNegativeNumber(stat?.daily_total);
    if (dailyTotal !== undefined) {
        return dailyTotal;
    }
    const validHourlyCounts = stat?.hours
        ?.map((hour) => toFiniteNonNegativeNumber(hour.count))
        .filter((count) => count !== undefined);
    return validHourlyCounts?.length
        ? validHourlyCounts.reduce((total, count) => total + count, 0)
        : undefined;
}
/** Resolves the deprecated daily audience value used only as a final fallback. */
function getLegacyDailyAudienceFallback(legacy) {
    const average = toFiniteNonNegativeNumber(legacy?.average);
    if (average !== undefined) {
        return average;
    }
    const min = toFiniteNonNegativeNumber(legacy?.min);
    const max = toFiniteNonNegativeNumber(legacy?.max);
    if (min !== undefined && max !== undefined) {
        return (min + max) / 2;
    }
    return min ?? max;
}
function resolveDailyAudience({ audienceStats, dayOfWeek, legacy, }) {
    const dayStats = audienceStats?.find((stat) => Number(stat.day_of_week) === dayOfWeek);
    return getAudienceStatDailyTotal(dayStats) ?? getLegacyDailyAudienceFallback(legacy);
}
function getAverageDailyAudience(audienceStats, legacy) {
    const dailyValues = audienceStats
        ?.map((stat) => getAudienceStatDailyTotal(stat))
        .filter((value) => value !== undefined);
    if (dailyValues?.length) {
        return dailyValues.reduce((total, value) => total + value, 0) / dailyValues.length;
    }
    return getLegacyDailyAudienceFallback(legacy);
}
